import React from 'react';

/**
 * HighlightPopup — Walter 2026-06-22. Passive legend shown by the caret while
 * you cycle a line's highlight with Ctrl+H (none → green → blue → red → none).
 *
 * Shows the full cycle: a "none" square (dotted, empty) first, then the three
 * colors — each captioned with its marker (^, ^^, ^^^) so the connection to the
 * text is obvious. The active step is ringed. It auto-fades after ~1.5s (the
 * `fading` prop drives an opacity transition); any key or click also dismisses
 * it (handled in useLineHighlight). pointer-events:none so it never eats a click.
 */
const STEPS = [
  { idx: 0, varName: null, carets: '' },   // none
  { idx: 1, varName: '--hl-green', carets: '^' },
  { idx: 2, varName: '--hl-blue', carets: '^^' },
  { idx: 3, varName: '--hl-red', carets: '^^^' },
];

export default function HighlightPopup({ x, y, active, fading }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        left: x, top: y,
        zIndex: 2360,
        pointerEvents: 'none',
        opacity: fading ? 0 : 1,
        transition: 'opacity 0.3s ease',
        display: 'flex', alignItems: 'flex-end', gap: 5,
        background: 'var(--surface)',
        border: '1px solid var(--accent)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow-popover)',
        padding: '6px 7px',
        fontFamily: 'var(--mono)',
      }}
    >
      {STEPS.map((s) => {
        const isActive = (active ?? 0) === s.idx;
        return (
          <div key={s.idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <span style={{
              height: 11, lineHeight: '11px',
              fontSize: 'calc(11px * var(--ui-scale, 1))',
              color: isActive ? 'var(--text)' : 'var(--text-dimmer)',
            }}>
              {s.carets}
            </span>
            <span style={{
              width: 24, height: 20, borderRadius: 4, boxSizing: 'border-box',
              background: s.varName ? `var(${s.varName})` : 'var(--surface-note)',
              border: s.varName
                ? (isActive ? '1.5px solid var(--text)' : '1px solid var(--border-bright)')
                : (isActive ? '1.5px solid var(--text)' : '1px dashed var(--border-bright)'),
              boxShadow: isActive ? '0 0 0 2px var(--surface), 0 0 0 3px var(--accent)' : 'none',
            }} />
          </div>
        );
      })}
    </div>
  );
}
